module.exports = __webpack_public_path__ + "Roboto-Regular.6a561d68369fd1fb9768.eot";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-Regular.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Regular.eot
// module chunks = 34